import {IVisualizerManager} from "./VisualizerContext";

import {IOptionSetRequest} from "../unreal_api/UnrealClient";
import {IMessageSender} from "./UnrealSignalRVisualizer";
import IVscCommunityMapInfo from "./IVscCommunityMapInfo";
import {IViewpoint} from "../data/IViewpoint";


export interface IUnrealVisualizerProps {

    unrealEndpoint: string;
}


export class BrowserWindowVisualizerManager implements IVisualizerManager {
    browse(sessionId: string, uri: string): void {
        window.open(uri, 'webvisualizer');
    }
    changeCameraToViewpoint(viewpoint: IViewpoint) {
        const qp = new URLSearchParams({viewpoint: viewpoint.Name});
        window.open('/server/Viewpoint.html?' + qp.toString(), 'webvisualizer');

    }

    playVideo(sessionId: string, file: string, looping: boolean): void {
        const qp = new URLSearchParams({video: file, looping: looping ? "1" : "0"});

        window.open('/server/BrowserVideo.html?' + qp.toString(), 'webvisualizer');
    }
    changeCamera(cameraId: string) {
        const qp = new URLSearchParams({camera: cameraId});
        window.open('/server/Camera.html?' + qp.toString(), 'webvisualizer');
    }

    async verifyConnection(): Promise<string | null> {
        return null;
    }

    sendOptions(req: IOptionSetRequest): void {
    }

    async connect() {
        return;
    }

    getMessageSender(): IMessageSender {
        return {
            sendMessage(msg: unknown) {
                console.log(JSON.stringify(msg));
            }
        }
    }

    requestMapInfo(): Promise<IVscCommunityMapInfo> {
        return Promise.reject();
    }

}


